import {gql} from "@apollo/client";
import { enrollmentApolloClient } from '@coverright/data-access/apollo-clients';
import * as _ from 'lodash';


export const validateEmail = _.debounce(validate, 500)

function validate(value?: string) {
  if (!!value && isEmailValid(value.toString())) {
    return new Promise((resolve, reject) => {
      enrollmentApolloClient.query({
        query: gql(query),
        variables: { email: value || '' }
      }).then(res => {
        resolve(res.data.checkUserExistenceByEmail === false)
      })
    }) as any
  } else {
    return false
  }
}

export const isEmailValid = (email: string) => (
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email.toLowerCase())
)


const query = `
query ($email: String!) {
  checkUserExistenceByEmail(email: $email)
}
`
